import SplitText from './SplitText.view';

export default SplitText;
